// project import
import grocery from './grocery';
import management from './management';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [grocery, management]
};

export default menuItems;
